import { apiRequest } from "./api-client";

export interface InformationItem {
  id: string;
  title: string;
  categoryId: string;
  categoryName: string;
  excerpt: string;
  version: number;
  publishedAt: string | null;
}

export interface InformationList {
  query: string;
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
  categories: { id: string; name: string; count: number }[];
  items: InformationItem[];
}

export interface InformationDetail extends Omit<InformationItem, "excerpt"> {
  content: string;
  summary: string | null;
}

export function fetchInformation(query: { q: string; category: string; page: number }, signal: AbortSignal) {
  const params = new URLSearchParams({ q: query.q, page: String(query.page) });
  if (query.category) params.set("category", query.category);
  return apiRequest<InformationList>(`/api/v1/app/information?${params}`, { signal });
}

export function fetchInformationDetail(id: string, signal: AbortSignal) {
  return apiRequest<InformationDetail>(`/api/v1/app/information/${encodeURIComponent(id)}`, { signal });
}
